( function () {
	'use strict';

	( function($){
		if( $('body').hasClass('single-modules') )
		$(document).on('click', '.btnWorkSheet', function(e){
			e.preventDefault();

		});



	} (jQuery) );

} )();